import { FormikValues, useFormikContext } from 'formik';
import React, { FunctionComponent } from 'react';
import { ExtendedRuleDefinition, FactDefinition } from '../../gen/api/api';
import { getFactDisplayConfig } from '../../shared/settings/config';
import useFieldValidation from '../../shared/validators/FieldValidator';

type FieldSetConfig = {
    id: string;
    name: string;
    factDefinition: FactDefinition;
    ruleDefinition: ExtendedRuleDefinition;
    disabled: boolean;
};

const { isFieldMandatory, compositeFieldLevelValidator } = useFieldValidation();

const FieldFactory: FunctionComponent<FieldSetConfig> = ({
    id,
    name,
    ruleDefinition,
    factDefinition,
    disabled,
    ...props
}) => {
    const { values } = useFormikContext<FormikValues>();

    const factConfig = getFactDisplayConfig(
        ruleDefinition.ruleCode.concat('.', factDefinition.factCode),
        factDefinition.factType,
    );

    const mandatory = isFieldMandatory(factDefinition, values);

    const validator = (value: any) => compositeFieldLevelValidator(value, mandatory, factConfig);

    return (
        <factConfig.component
            {...props}
            id={id}
            fieldName={name}
            fieldOptions={factConfig.props.options}
            optionsMethod={factConfig.props.autocompleteOptionsMethod}
            getByIdMethod={factConfig.props.getByIdMethod}
            fieldLabel={factDefinition.factName}
            fieldValidator={validator}
            required={mandatory}
            type={factConfig.props.type}
            disabled={disabled}
            codeListName={factConfig.props.codelist}
            multiple={factConfig.props.multiple}
            defaultValue={factConfig.props.defaultValue}
        />
    );
};

export default FieldFactory;
